export interface IncrementIconProps {
  invertColor?: boolean;
}

const IncrementIcon = ({ invertColor }: IncrementIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
      <mask id="mask0_7408_85322" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="16">
        <rect x="12" y="16" width="12" height="16" transform="rotate(-180 12 16)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7408_85322)">
        <path
          d="M6.8335 6.16732L6.8335 13.0007C6.8335 13.2368 6.75363 13.4347 6.59391 13.5944C6.43419 13.7541 6.23627 13.834 6.00016 13.834C5.76405 13.834 5.56614 13.7541 5.40641 13.5944C5.24669 13.4347 5.16683 13.2368 5.16683 13.0007L5.16683 6.16732L2.75016 8.58398C2.59738 8.73676 2.40294 8.81315 2.16683 8.81315C1.93072 8.81315 1.73627 8.73676 1.5835 8.58398C1.43072 8.43121 1.35433 8.23676 1.35433 8.00065C1.35433 7.76454 1.43072 7.5701 1.5835 7.41732L5.41683 3.58398C5.5835 3.41732 5.77794 3.33398 6.00016 3.33398C6.22238 3.33398 6.41683 3.41732 6.5835 3.58398L10.4168 7.41732C10.5696 7.5701 10.646 7.76454 10.646 8.00065C10.646 8.23676 10.5696 8.43121 10.4168 8.58398C10.2641 8.73676 10.0696 8.81315 9.8335 8.81315C9.59739 8.81315 9.40294 8.73676 9.25016 8.58398L6.8335 6.16732Z"
          fill={invertColor ? 'var(--red-base)' : 'var(--green-base)'}
        />
      </g>
    </svg>
  );
};

export default IncrementIcon;
